import { render } from "./SettlementModal.vue?vue&type=template&id=665fe9d0&scoped=true"
import script from "./SettlementModal.vue?vue&type=script&lang=js"
export * from "./SettlementModal.vue?vue&type=script&lang=js"

import "./SettlementModal.vue?vue&type=style&index=0&id=665fe9d0&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665fe9d0"]])

export default __exports__